<template>
  <span class="inline-flex items-center gap-1 align-middle">
    <slot />
    <span v-if="required" class="text-error">*</span>
    <UPopover v-if="tip" mode="hover" :open-delay="120">
      <UIcon
        name="material-symbols-light:info-outline-rounded"
        class="text-gray-500"
        style="font-size: 1.1em"
      />
      <template #content>
        <div class="p-2 text-xs max-w-xs">{{ tip }}</div>
      </template>
    </UPopover>
  </span>
</template>

<script setup>
defineProps({
  tip: String,
  required: Boolean,
});
</script>